const getAlbumId = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const albumIdFromUrl = urlParams.get("album_id");
  return albumIdFromUrl;
};

export default getAlbumId;
